

export enum CREATE_ACCOUNT_STEPS {
    ACCOUNT_DETAILS = 0,
    ACCOUNT_SETTINGS = 1,
    LICENSE_CREATE = 2,
}

export const CREATE_ACCOUNT_ROUTES = {
    [CREATE_ACCOUNT_STEPS.ACCOUNT_DETAILS]: 'details',
    [CREATE_ACCOUNT_STEPS.ACCOUNT_SETTINGS]: 'settings',
    [CREATE_ACCOUNT_STEPS.LICENSE_CREATE]: 'license',
};

export const STEP_TITLE = {
    [CREATE_ACCOUNT_STEPS.ACCOUNT_DETAILS]: 'Account details',
    [CREATE_ACCOUNT_STEPS.ACCOUNT_SETTINGS]: 'Account settings',
    [CREATE_ACCOUNT_STEPS.LICENSE_CREATE]: 'Create license',
};
